import router from './router';
import store from './store/index';
import { Message } from 'element-ui';
import { getToken } from '@/utils/auth'; // 验权

const whiteList = ['/login']; // 不重定向白名单
router.beforeEach((to, from, next) => {
  if (getToken()) {
    if (to.path === '/login') {
      next({ path: '/' });
    } else if (store.getters.token.length === 0) {
      store.dispatch('GetInfo').then(() => { // 拉取用户信息
        next();
      }).catch((err) => {
        store.dispatch('FedLogOut').then(() => {
          Message.error(err || 'Verification failed, please login again');
          next({ path: '/login' });
        });
      });
    } else {
      next();
    }
  } else if (whiteList.indexOf(to.path) !== -1) {
    next();
  } else {
    next(`/login?redirect=${to.path}`); // 否则全部重定向到登录页
  }
});
